const modal: any = {
  namespaced: true,
  state() {
    return {
      data: {}
    }
  },
  mutations: {
    open(state, payload) {
      if (payload?.uid) {
        const res = state.data[payload.uid]
        if (res) {
          state.data[payload.uid] = { ...payload, show: true }
        } else {
          state.data[payload.uid] = { ...payload, show: true }
        }
      }
    },
    close(state, payload) {
      if (payload?.uid) {
        const res = state.data[payload.uid]
        if (res) {
          state.data[payload.uid].show = false
        }
      } else {
        // 关闭全部弹框
        Object.keys(state.data).forEach((key) => {
          state.data[key].show = false
        })
      }
    }
  },
  actions: {}
}

export default modal
